import styled from 'styled-components';
import { colors } from 'nicollet-tokens';
import { Picture } from '../../../Picture/index.js';

const StyledImage = styled(Picture)`
  img {
    max-width: 20px;
    margin-right: 10px;

    border-radius: 2px;
    border-width: 1px;
    border-color: ${colors.palette.gray.medium};
    border-style: solid;
  }
`;
const focusDotStyles = `
  &::before {
    content: '';
    outline: 0;
    background: ${colors.link.onLight.hover};
    height: 5px;
    width: 5px;
    border-radius: 100%;
    position: absolute;
    top: 45%;
    top: calc(50% - 2.5px);
    left: -10px;
  }
`;

export { StyledImage, focusDotStyles };
